"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserNamesReducer = exports.getRecentTrainingJobReducers = exports.getNextModelVersionReducers = exports.getUpdateModelReducers = exports.recordDeploymentReducers = exports.getLatestDeploymentByVersionLuidReducers = exports.getDeployedVersionReducers = exports.getDraftIDReducers = exports.moveModelReducers = exports.getSetModelNameReducers = exports.getEditModelReducers = exports.getCreateModelReducers = exports.getRecentTrainingJob = exports.getNextModelVersion = exports.updateModel = exports.recordDeployment = exports.getTrainingJobUsername = exports.getLatestDeploymentByVersionLuid = exports.getDeployedVersion = exports.getDraftID = exports.moveModel = exports.setModelName = exports.editModel = exports.createModel = exports.showErrorToast = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var widgets_1 = require("@tableau/widgets");
var Utils_1 = require("../../util/Utils");
var CreateNextPredictiveModelVersion_1 = require("../../vizportalapi/CreateNextPredictiveModelVersion");
var GetDeployedVersion_1 = require("../../vizportalapi/GetDeployedVersion");
var GetLatestDeploymentByVersionLuid_1 = require("../../vizportalapi/GetLatestDeploymentByVersionLuid");
var GetPredictiveModel_1 = require("../../vizportalapi/GetPredictiveModel");
var GetPredictiveModelDraftID_1 = require("../../vizportalapi/GetPredictiveModelDraftID");
var MovePredictiveModel_1 = require("../../vizportalapi/MovePredictiveModel");
var PredictiveModelJobOperations_1 = require("../../vizportalapi/PredictiveModelJobOperations");
var PredictiveModelUserOperations_1 = require("../../vizportalapi/PredictiveModelUserOperations");
var RecordPredictiveModelVersionDeployment_1 = require("../../vizportalapi/RecordPredictiveModelVersionDeployment");
var SetPredictiveModelName_1 = require("../../vizportalapi/SetPredictiveModelName");
var UpdatePredictiveModel_1 = require("../../vizportalapi/UpdatePredictiveModel");
var showErrorToast = function (message, testId) {
    if (testId === void 0) { testId = 'redux-error-id'; }
    // This still breaks tests for unhandled promise error intermittenttly. Adding try catch block back.
    try {
        widgets_1.ToastWidget.show({
            message: message,
            testId: testId,
            toastType: widgets_1.ToastType.Error,
        });
    }
    catch (err) {
        //No OP
    }
};
exports.showErrorToast = showErrorToast;
var CREATE_MODEL = 'model/createModel';
var EDIT_MODEL = 'model/editModel';
var SET_MODEL_NAME = 'model/setModelName';
var MOVE_MODEL = 'model/moveModel';
var GET_DRAFT_ID = 'model/getDraftID';
var GET_DEPLOYED_VERSION = 'model/getDeployedVersion';
var GET_LATEST_DEPLOYMENT = 'model/getLatestDeploymentByVersionLuid';
var RECORD_DEPLOYMENT = 'model/recordDeployment';
var UPDATE_MODEL = 'UPDATE_MODEL';
var UPDATE_MODEL_INTERNAL = 'UPDATE_MODEL_INTERNAL';
var GET_NEXT_MODEL_VERSION = 'GET_NEXT_MODEL_VERSION';
var GET_MOST_RECENT_JOB_BY_VERSION = 'GET_MOST_RECENT_JOB_BY_VERSION';
var GET_USER_NAMES = 'model/getUserNames';
exports.createModel = (0, toolkit_1.createAsyncThunk)(CREATE_MODEL, function () { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, GetPredictiveModel_1.GetPredictiveModel.createModel()];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}); });
exports.editModel = (0, toolkit_1.createAsyncThunk)(EDIT_MODEL, function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, GetPredictiveModel_1.GetPredictiveModel.getModelByLuid(params.luid)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.setModelName = (0, toolkit_1.createAsyncThunk)(SET_MODEL_NAME, function (params, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                return [4 /*yield*/, SetPredictiveModelName_1.SetPredictiveModelName.setName(state.predictiveModel.model.luid, params.name)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.moveModel = (0, toolkit_1.createAsyncThunk)(MOVE_MODEL, function (params, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                return [4 /*yield*/, MovePredictiveModel_1.MovePredictiveModel.moveModel(state.predictiveModel.model.id, params.containerId)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.getDraftID = (0, toolkit_1.createAsyncThunk)(GET_DRAFT_ID, function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, GetPredictiveModelDraftID_1.GetPredictiveModelDraftID.getPredictiveModelDraftID(params.flowID)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.getDeployedVersion = (0, toolkit_1.createAsyncThunk)(GET_DEPLOYED_VERSION, function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                return [4 /*yield*/, GetDeployedVersion_1.GetDeployedVersion.getVersion(state.predictiveModel.model.luid)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.getLatestDeploymentByVersionLuid = (0, toolkit_1.createAsyncThunk)(GET_LATEST_DEPLOYMENT, function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, GetLatestDeploymentByVersionLuid_1.GetLatestDeploymentByVersionLuid.getDeployment(params.versionLuid)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
// This is temporary work to get the trainingJobUsername by jobOwnerId. Eventually backend will take care of it
// If it lives longer, we should probably do things like save the userId on success and check the saved id against the current one to see if we should actually make the network call.
exports.getTrainingJobUsername = (0, toolkit_1.createAsyncThunk)(GET_USER_NAMES, function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, PredictiveModelUserOperations_1.PredictiveModelUserOperations.getUserNameByUserId(params.userId)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.recordDeployment = (0, toolkit_1.createAsyncThunk)(RECORD_DEPLOYMENT, function (params, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                return [4 /*yield*/, RecordPredictiveModelVersionDeployment_1.RecordPredictiveModelVersionDeployment.recordDeployment(state.predictiveModel.model.activeVersion.luid, params.einsteinDeployedModelId, params.einsteinPredictionDefinitionId)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
// We use 2 nested thunks for update. The outer is just used to stash the old state in the thunk argument to the inner thunk so it can be used to undo
exports.updateModel = (0, toolkit_1.createAsyncThunk)(UPDATE_MODEL, function (params, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, previousVersionState, key, value, updateProperties, newArgs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                previousVersionState = {};
                for (key in params) {
                    value = state.predictiveModel.model.activeVersion[key];
                    previousVersionState[key] = value;
                }
                updateProperties = __assign(__assign({}, params), { lockVersion: state.predictiveModel.model.activeVersion.lockVersion });
                newArgs = {
                    previousState: previousVersionState,
                    updateProperties: updateProperties,
                };
                return [4 /*yield*/, thunkAPI.dispatch(updateModelInternal(newArgs)).unwrap()];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
var updateModelInternal = (0, toolkit_1.createAsyncThunk)(UPDATE_MODEL_INTERNAL, function (params, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, update;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                update = {
                    luid: state.predictiveModel.model.activeVersion.luid,
                    version: params.updateProperties,
                };
                return [4 /*yield*/, UpdatePredictiveModel_1.UpdatePredictiveModel.updateModel(update)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.getNextModelVersion = (0, toolkit_1.createAsyncThunk)(GET_NEXT_MODEL_VERSION, function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                return [4 /*yield*/, CreateNextPredictiveModelVersion_1.CreateNextPredictiveModelVersion.createNextVersion(state.predictiveModel.model.luid)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
exports.getRecentTrainingJob = (0, toolkit_1.createAsyncThunk)(GET_MOST_RECENT_JOB_BY_VERSION, function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, params;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                params = {
                    versionLuid: state.predictiveModel.model.activeVersion.luid,
                };
                return [4 /*yield*/, PredictiveModelJobOperations_1.PredictiveModelJobOperations.findRecentJobsByVersionId(params)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); });
var getCreateModelReducers = function (builder) {
    builder.addCase(exports.createModel.fulfilled, function (state, _a) {
        var payload = _a.payload;
        state.model = payload;
        state.loadResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.loadResponse.error = null;
        // Update URL with our ID
        window.history.replaceState(null, '', "".concat(window.location.href, "/").concat(payload.luid));
    });
    builder.addCase(exports.createModel.pending, function (state) {
        state.loadResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.createModel.rejected, function (state, action) {
        state.loadResponse.status = Utils_1.REDUX_STATUS.failed;
        state.loadResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot create model'); // TODO TFS Task 1399735
    });
};
exports.getCreateModelReducers = getCreateModelReducers;
var getEditModelReducers = function (builder) {
    builder.addCase(exports.editModel.fulfilled, function (state, _a) {
        var payload = _a.payload;
        state.model = payload;
        state.loadResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.loadResponse.error = null;
    });
    builder.addCase(exports.editModel.pending, function (state) {
        state.loadResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.editModel.rejected, function (state, action) {
        state.loadResponse.status = Utils_1.REDUX_STATUS.failed;
        state.loadResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot edit model'); // TODO TFS Task 1399735
    });
};
exports.getEditModelReducers = getEditModelReducers;
var getSetModelNameReducers = function (builder) {
    builder.addCase(exports.setModelName.fulfilled, function (state) {
        state.setNameResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.setNameResponse.error = null;
    });
    builder.addCase(exports.setModelName.pending, function (state, action) {
        // Save the current name before the change so we can undo on error. Optimistically update the new name.
        state.setNameResponse.previousName = state.model.name;
        state.model.name = action.meta.arg.name;
        state.setNameResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.setModelName.rejected, function (state, action) {
        // Undo the optimistic change
        state.model.name = state.setNameResponse.previousName;
        state.setNameResponse.status = Utils_1.REDUX_STATUS.failed;
        state.setNameResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot set model name'); // TODO TFS Task 1399735
    });
};
exports.getSetModelNameReducers = getSetModelNameReducers;
var moveModelReducers = function (builder) {
    builder.addCase(exports.moveModel.fulfilled, function (state) {
        state.moveModelResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.moveModelResponse.error = null;
    });
    builder.addCase(exports.moveModel.pending, function (state) {
        state.moveModelResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.moveModel.rejected, function (state, action) {
        state.moveModelResponse.status = Utils_1.REDUX_STATUS.failed;
        state.moveModelResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot set model location'); // TODO TFS Task 1399735
    });
};
exports.moveModelReducers = moveModelReducers;
var getDraftIDReducers = function (builder) {
    builder.addCase(exports.getDraftID.fulfilled, function (state, _a) {
        var payload = _a.payload;
        state.getDraftIDResponse.currentDraftID = payload;
        state.getDraftIDResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.getDraftIDResponse.error = null;
    });
    builder.addCase(exports.getDraftID.pending, function (state) {
        state.getDraftIDResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.getDraftID.rejected, function (state, action) {
        state.getDraftIDResponse.status = Utils_1.REDUX_STATUS.failed;
        state.getDraftIDResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot get draft id'); // TODO TFS Task 1399735
    });
};
exports.getDraftIDReducers = getDraftIDReducers;
var getDeployedVersionReducers = function (builder) {
    builder.addCase(exports.getDeployedVersion.fulfilled, function (state, _a) {
        var payload = _a.payload;
        state.getDeployedVersionResponse.deployedVersion = payload;
        state.getDeployedVersionResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.getDeployedVersionResponse.error = null;
    });
    builder.addCase(exports.getDeployedVersion.pending, function (state) {
        state.getDeployedVersionResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.getDeployedVersion.rejected, function (state, action) {
        state.getDeployedVersionResponse.status = Utils_1.REDUX_STATUS.failed;
        state.getDeployedVersionResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot get deployed version'); // TODO TFS Task 1399735
    });
};
exports.getDeployedVersionReducers = getDeployedVersionReducers;
var getLatestDeploymentByVersionLuidReducers = function (builder) {
    builder.addCase(exports.getLatestDeploymentByVersionLuid.fulfilled, function (state, _a) {
        var payload = _a.payload;
        state.getLatestDeploymentByVersionLuidResponse.latestDeployment = payload;
        state.getLatestDeploymentByVersionLuidResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.getLatestDeploymentByVersionLuidResponse.error = null;
    });
    builder.addCase(exports.getLatestDeploymentByVersionLuid.pending, function (state) {
        state.getLatestDeploymentByVersionLuidResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.getLatestDeploymentByVersionLuid.rejected, function (state, action) {
        state.getLatestDeploymentByVersionLuidResponse.status = Utils_1.REDUX_STATUS.failed;
        state.getLatestDeploymentByVersionLuidResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot get latest deployment'); // TODO TFS Task 1399735
    });
};
exports.getLatestDeploymentByVersionLuidReducers = getLatestDeploymentByVersionLuidReducers;
var recordDeploymentReducers = function (builder) {
    builder.addCase(exports.recordDeployment.fulfilled, function (state) {
        state.recordDeploymentResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.recordDeploymentResponse.error = null;
    });
    builder.addCase(exports.recordDeployment.pending, function (state) {
        state.recordDeploymentResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.recordDeployment.rejected, function (state, action) {
        state.recordDeploymentResponse.status = Utils_1.REDUX_STATUS.failed;
        state.recordDeploymentResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot record deployment'); // TODO TFS Task 1399735
    });
};
exports.recordDeploymentReducers = recordDeploymentReducers;
// We use an optimistic update pattern here. We update the state in pending assuming it will be successful. And then undo that state change if we fail
var getUpdateModelReducers = function (builder) {
    builder.addCase(updateModelInternal.fulfilled, function (state, _a) {
        var payload = _a.payload;
        // Assuming the call returns the entire model. Let's update it just to be sure
        state.model = payload;
        state.updateResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.updateResponse.error = null;
    });
    builder.addCase(updateModelInternal.pending, function (state, action) {
        state.updateResponse.status = Utils_1.REDUX_STATUS.loading;
        // Optimistically update the model version with the new data
        state.model.activeVersion = Object.assign(state.model.activeVersion, action.meta.arg.updateProperties);
    });
    builder.addCase(updateModelInternal.rejected, function (state, action) {
        // Undo the optimistic change by putting the previous state back
        Object.assign(state.model.activeVersion, action.meta.arg.previousState);
        state.updateResponse.status = Utils_1.REDUX_STATUS.failed;
        state.updateResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot update model'); // TODO TFS Task 1399735
    });
};
exports.getUpdateModelReducers = getUpdateModelReducers;
var getNextModelVersionReducers = function (builder) {
    builder.addCase(exports.getNextModelVersion.fulfilled, function (state, _a) {
        var payload = _a.payload;
        state.model.activeVersion = payload;
        state.getNextModelVersionResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.getNextModelVersionResponse.error = null;
    });
    builder.addCase(exports.getNextModelVersion.pending, function (state) {
        state.getNextModelVersionResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.getNextModelVersion.rejected, function (state, action) {
        state.getNextModelVersionResponse.status = Utils_1.REDUX_STATUS.failed;
        state.getNextModelVersionResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot get new model version'); // TODO TFS Task 1399735
    });
};
exports.getNextModelVersionReducers = getNextModelVersionReducers;
var getRecentTrainingJobReducers = function (builder) {
    builder.addCase(exports.getRecentTrainingJob.fulfilled, function (state, _a) {
        var payload = _a.payload;
        state.job = payload;
        state.getRecentTrainingJobResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.getRecentTrainingJobResponse.error = null;
    });
    builder.addCase(exports.getRecentTrainingJob.pending, function (state) {
        state.getRecentTrainingJobResponse.status = Utils_1.REDUX_STATUS.loading;
    });
    builder.addCase(exports.getRecentTrainingJob.rejected, function (state, action) {
        state.getRecentTrainingJobResponse.status = Utils_1.REDUX_STATUS.failed;
        state.getRecentTrainingJobResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot get version job'); // TODO TFS Task 1399735
    });
};
exports.getRecentTrainingJobReducers = getRecentTrainingJobReducers;
var getUserNamesReducer = function (builder) {
    builder.addCase(exports.getTrainingJobUsername.fulfilled, function (state, _a) {
        var payload = _a.payload;
        state.getUserNamesResponse.trainingJobUsername = payload;
        state.getUserNamesResponse.status = Utils_1.REDUX_STATUS.succeeded;
        state.getUserNamesResponse.error = null;
    });
    builder.addCase(exports.getTrainingJobUsername.pending, function (state, action) {
        var _a;
        state.getUserNamesResponse.status = Utils_1.REDUX_STATUS.loading;
        state.getUserNamesResponse.trainingJobUsername = (_a = action.meta.arg.userId) !== null && _a !== void 0 ? _a : '';
    });
    builder.addCase(exports.getTrainingJobUsername.rejected, function (state, action) {
        state.getUserNamesResponse.status = Utils_1.REDUX_STATUS.failed;
        state.getUserNamesResponse.error = action.error.message;
        (0, exports.showErrorToast)('Error: cannot get user names');
    });
};
exports.getUserNamesReducer = getUserNamesReducer;
//# sourceMappingURL=PredictiveModelThunk.js.map